import { v4 as uuidv4 } from 'uuid';

export function Minicart(props, childrenComponents = []) {
	return {
		componentName: 'Minicart',
		componentId: uuidv4(),
		props: Object.assign(
			{
				variation: 'drawer',
				drawerSlideDirection: 'rightToLeft',
				maxDrawerWidth: 440,
				openOnHover: false,
				quantityDisplay: 'not-empty',
				itemCountMode: 'distinct',
				backdropMode: 'visible',
				customPixelEventId: 'add-to-cart-button',
				customPixelEventName: '',
			},
			props,
		),
		childrenComponents,
	};
}
